let _Vue
const $api = {}

const requireContext = require.context('.', true, /\.js$/)

requireContext.keys().forEach(fileName => {
  const mod = requireContext(fileName)
  const modName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '')

  if (modName !== 'index') {
    $api[modName] = mod.default
  }
})

const descriptor = Object.create(null)
descriptor.get = function () {
  return $api
}

export default {
  ...$api,
  install(Vue) {
    if (Vue && _Vue === Vue) return

    _Vue = Vue

    Object.defineProperty(Vue.prototype, '$api', descriptor)
  }
}
